import React from 'react';
import { CARD_LONG as W, CARD_SHORT as H } from '../../catalog';
import { V, T, Svg, Path } from '../primitives';
import { CardFaceProps, DetailGrid, Logo, Photo, Validity, faceBase, faceData, nameStyle, type } from './shared';

const MAST = 40;
const FOOT = 15;

/** Classic — a colour masthead with the school, the photo beside the details. */
const ClassicFront: React.FC<CardFaceProps> = (props) => {
  const { design, person, photo, school, validUntil } = props;
  const { palette, details } = faceData(props);
  return (
    <V style={faceBase(W, H, palette.paper)}>
      {/* Masthead */}
      <V style={{ height: MAST, backgroundColor: palette.primary, flexDirection: 'row', alignItems: 'center', paddingHorizontal: 11 }}>
        <Svg width={120} height={MAST} viewBox={`0 0 120 ${MAST}`} style={{ position: 'absolute', right: 0, top: 0 }}>
          <Path d={`M58 0 H74 L50 ${MAST} H34 Z`} fill={palette.accent} />
          <Path d={`M80 0 H120 V${MAST} H56 Z`} fill={palette.primaryDeep} opacity={0.55} />
          <Path d={`M86 0 H90 L66 ${MAST} H62 Z`} fill={palette.onPrimary} opacity={0.22} />
        </Svg>
        <Logo school={school} size={26} palette={palette} tile />
        <V style={{ flex: 1, marginLeft: 8, paddingRight: 62 }}>
          <T style={{ fontSize: 8.2, fontWeight: 700, color: palette.onPrimary, letterSpacing: -0.1 }} lines={1}>{school.name}</T>
          <T style={[type.caps, { color: palette.accent, marginTop: 2.5 }]} lines={1}>{design.title}</T>
        </V>
      </V>
      <V style={{ height: 1.6, backgroundColor: palette.accent }} />

      {/* Holder */}
      <V style={{ flexDirection: 'row', paddingHorizontal: 12, paddingTop: 9 }}>
        <Photo photo={photo} name={person.name} width={58} height={72} radius={5} palette={palette}
          ring={{ width: 1.4, color: palette.hairline }} />
        <V style={{ flex: 1, marginLeft: 11 }}>
          <T style={[nameStyle(person.name, 10.6), { color: palette.ink }]} lines={2}>{person.name}</T>
          <V style={{ width: 18, height: 1.6, backgroundColor: palette.accent, borderRadius: 1, marginTop: 4, marginBottom: 5 }} />
          <DetailGrid details={details} palette={palette} />
        </V>
      </V>

      {/* Footer */}
      <V style={{ position: 'absolute', left: 0, right: 0, bottom: 0, height: FOOT, backgroundColor: palette.wash, flexDirection: 'row', alignItems: 'center', paddingHorizontal: 12 }}>
        <V style={{ flex: 1 }}>
          <Validity validUntil={validUntil} color={palette.ink} labelColor={palette.inkFaint} />
        </V>
        <T style={[type.caps, { fontSize: 4.3, color: palette.primaryText }]}>{design.audience === 'student' ? 'Student' : 'Staff'}</T>
      </V>
    </V>
  );
};

export default ClassicFront;
